/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import {
  Label,
  LabelList,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from "recharts";

import BaseGraph from "./BaseGraph";
import { useNitroStore } from "../store/Store";
import { formatByCalendarType, getAdjustedYears } from "../utils/Dates";
import { useIsComponentMounted } from "../hooks/useIsComponentMounted";
import NitroService from "../utils/nitro.service";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TitleTransferGraph = () => {
  const [mode, product] = useNitroStore((state) => [state.mode, state.product]);

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([] as any[]);
  const [rows, setRows] = useState([] as any[]);

  const startYear = new Date().getFullYear() - 4;
  const endYear = new Date().getFullYear();

  useEffect(() => {
    const newRows = formatByCalendarType(data, {
      calendarFormat: "cal",
      startYear,
      endYear,
      property: "titleTransfer",
    });

    const origin = newRows.find((r) => r.titleTransfer === "ORIGIN");
    const destination = newRows.find((r) => r.titleTransfer === "DESTINATION");
    if (!origin || !destination) {
      setRows([]);
      setLoading(false);
      return;
    }

    const keys = ["year1", "year2", "year3", "year4", "year5"];
    const years = getAdjustedYears(endYear, "cal");

    const records = keys.map((key, i) => {
      const o = origin[key] || 0;
      const d = destination[key] || 0;
      const originPercent = Math.round((o / (o + d)) * 100);
      const destinationPercent = 100 - originPercent;

      return {
        year: `${years[i]}`,
        origin: originPercent,
        destination: destinationPercent,
      };
    });

    setRows(records);
  }, [data, startYear, endYear]);

  const isComponentMounted = useIsComponentMounted();
  useEffect(() => {
    if (!isComponentMounted) return;

    const load = async () => {
      // if (!customerName && (!cityNames || cityNames.length === 0)) {
      //   setData([]);
      //   return;
      // }

      try {
        setLoading(true);
        // const result = await NitroService.proxy(
        //   "TitleTransfer",
        //   {
        //     customerName: encodeURIComponent("GROWMARK INC"),
        //     productType: product,
        //     modes: [mode],
        //     // industry,
        //     // marketer,
        //     // cityNames,
        //     // stateNames,
        //     startYear,
        //     endYear,
        //   },
        //   1,
        //   1000
        // );

        // setData(result);
      } catch (err) {
        console.error(err);
      }

      setLoading(false);
    };

    load();
  }, [isComponentMounted, mode, product, startYear, endYear]);

  const infoMessage = (
    <>
      <b>Filter criteria</b>: Customer Name, Product Type, Modes, Industry,
      Cities, States
    </>
  );

  const body = (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={rows} layout="vertical" margin={{ bottom: 8 }}>
        <XAxis type="number" hide>
          <Label fontSize={14} />
        </XAxis>
        <YAxis
          type="category"
          dataKey="year"
          axisLine={false}
          width={42}
          fontSize={12}
          fontWeight={700}
          color="#231F20"
        />
        {/* <Tooltip
      content={<CustomTooltip />}
      /> */}
        <Bar dataKey="destination" fill="#00A0DF" stackId="a">
          <LabelList
            dataKey="destination"
            position="insideLeft"
            fill="#FFFFFF"
            style={{ fontWeight: 700, fontSize: 12 }}
            formatter={(val: any) => {
              if (!val || val < 6) return "";

              return `${val}%`;
            }}
          />
        </Bar>
        <Bar dataKey="origin" fill="#D9D9D9" stackId="a">
          <LabelList
            dataKey="origin"
            position="insideRight"
            fill="#231F20"
            style={{ fontWeight: 700, fontSize: 12 }}
            formatter={(val: any) => {
              if (!val || val < 6) return "";
              return `${val}%`;
            }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );

  return (
    <BaseGraph
      loading={loading}
      title="PERCENT DELIVERED"
      infoMessage={infoMessage}
      height={200}
    >
      {body}
    </BaseGraph>
  );
};

export default TitleTransferGraph;
